import { render, staticRenderFns } from "./ProcessInstanceTabs.vue?vue&type=template&id=7c9d3637&scoped=true"
import script from "./ProcessInstanceTabs.vue?vue&type=script&lang=js"
export * from "./ProcessInstanceTabs.vue?vue&type=script&lang=js"
import style0 from "./ProcessInstanceTabs.vue?vue&type=style&index=0&id=7c9d3637&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9d3637",
  null
  
)

export default component.exports